
import React, { Fragment, useState } from 'react'

import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation'

import './ButtonAddTeam.scss'

interface Props {
  className?: string
}

const ButtonAddTeam = ({ className }: Props) => {

  const { t } = useTranslation()

  const { setShowTeamCreator } = useTeams()

  return (
    <button className={`btn btn-add-team ${className}`}
      onClick={() => setShowTeamCreator(true)}
    >
      <span className="icon-agregar_equipo"></span>
      <span className='button-text'>{' '}
        {t('TEAMS:ToolbarCreateTeamButton')}
      </span>
    </button>
  )
}

export default ButtonAddTeam
